import React, { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { visibleGroups, groupKey } from "@/lib/nav";
import TileArt from "@/components/TileArt";
import { useTheme, isModernTheme } from "@/lib/uiTheme";

/** Pagina unui modul: plăci către paginile lui (după drepturile utilizatorului). */
export default function ModuleHome() {
  const { key } = useParams();
  const theme = useTheme();
  const { hasRole, hasModule, allowed, activationRequired } = useAuth();
  const [isClientInstall, setIsClientInstall] = useState(false);
  useEffect(() => { api.get("/config/deployment").then(r => setIsClientInstall(!!r.data.is_client_install)).catch(() => {}); }, []);
  const group = visibleGroups({ hasRole, hasModule, allowed, activationRequired, isClientInstall, theme: "purple" }).find(g => groupKey(g) === key);
  if (!isModernTheme(theme) || !group) return <Navigate to="/" replace />;
  return (
    <div data-testid={`module-${key}`}>
      <h1 style={{ fontSize: 26, fontWeight: 800, margin: "4px 0 18px" }}>{group.title}</h1>
      <div className="tiles">
        {group.items.map(it => (
          <Link key={it.to} to={it.to} className="tile" data-testid={`tile-${it.to.replace(/\//g, "-").replace(/^-/, "")}`}><TileArt /><span>{it.label}</span></Link>))}
      </div>
    </div>
  );
}
